import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const ANCHOR_IMAGE = 'https://files.tnonetwork.com/users/talent/lilianafernandes.jpg';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Vivir en Equilibrio: bienestar integral para mente, cuerpo y alma
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio de TNO Network donde la audiencia encuentra herramientas prácticas para una vida plena: equilibrio físico, foco mental, hábitos saludables y calidad de vida sostenible.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Vivir en Equilibrio?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/vivirenequilibrio"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/vivirenequilibrio
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Programa de bienestar 360° con <strong>Liliana Fernandes</strong>: conversación cercana, invitados expertos y contenido accionable sobre salud, productividad y equilibrio emocional. Presencia en vivo, On-Demand y redes del ecosistema TNO Network.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={ANCHOR_IMAGE}
                alt="Liliana Fernandes - Ancla de Vivir en Equilibrio"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: LILIANA FERNANDES
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              La voz que conecta bienestar, constancia y transformación personal
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Liliana Fernandes</strong> conduce <strong>Vivir en Equilibrio</strong> en TNO Network. Su enfoque humaniza marcas y temas de salud: entrenamiento con método, recuperación, foco mental y rutinas sostenibles. Ideal para patrocinadores de fitness, wellness, nutrición y estilo de vida activo.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
